import {Box, Link} from '@customink/pigment-react';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {firePdpInteractionClickEvent} from 'utils/analytics';
import DeliveryOptions from './ProductHero/DeliveryOptions';
import ProductDescription from './ProductHero/ProductDescription';
import ProductDetails from './ProductHero/ProductDetails';

const HeightRestrictedSection = ({children}) => {
  const restrictedHeight = 650;
  const [isExpanded, setIsExpanded] = useState(true);
  const [shouldShowMore, setShouldShowMore] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.getBoundingClientRect().height;
      if (contentHeight > restrictedHeight) {
        setIsExpanded(false);
        setShouldShowMore(true);
      }
    }
  }, []);

  const handleSeeMoreClick = () => {
    firePdpInteractionClickEvent('product information', 'see more');
    setIsExpanded(!isExpanded);
    setShouldShowMore(false);
  };

  return (
    <Box
      sx={{
        '@media (max-width: 768px)': {display: 'none'},
        position: 'relative'
      }}>
      <Box
        ref={contentRef}
        sx={{
          maxHeight: isExpanded ? `none` : `${restrictedHeight}px`,
          overflow: 'hidden',
          paddingBottom: '2rem',
          position: 'relative',
          transition: 'max-height 0.5s cubic-bezier(0, 1, 0, 1)'
        }}>
        {children}
      </Box>

      {shouldShowMore && !isExpanded && (
        <>
          <Box
            sx={{
              background:
                'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)',
              bottom: 0,
              height: '9rem',
              left: 0,
              pointerEvents: 'none',
              position: 'absolute',
              right: 0
            }}
          />
          <Box
            sx={{
              bottom: '1.25rem',
              display: 'flex',
              justifyContent: 'center',
              left: 0,
              position: 'absolute',
              right: 0,
              zIndex: 1
            }}>
            <Link
              onClick={handleSeeMoreClick}
              sx={{
                cursor: 'pointer',
                fontSize: '0.875rem',
                fontWeight: 'bold',
                padding: '0.5rem 1rem'
              }}>
              See More
            </Link>
          </Box>
        </>
      )}
    </Box>
  );
};

const ProductDetailsSeeMore = ({status}) => {
  const isPreview = React.useMemo(() => status === 'preview', [status]);
  return (
    <HeightRestrictedSection data-testid="product-details-see-more">
      <Box
        sx={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          margin: '0 auto',
          maxWidth: '80em'
        }}>
        <Box sx={{flex: 1}}>
          <ProductDescription useAccordion={false} />
        </Box>
        <Box sx={{flex: 1}}>
          <ProductDetails useAccordion={false} />
        </Box>
        {!isPreview && (
          <Box sx={{flex: 1}}>
            <DeliveryOptions useAccordion={false} />
          </Box>
        )}
      </Box>
    </HeightRestrictedSection>
  );
};

export default ProductDetailsSeeMore;
